import { localization } from '@ocean/configs'
import { namespace } from 'modules/virtualClassrooms/common/localization'
import { VirtualEventScheduleStatus } from 'modules/virtualClassrooms/manager/Schedules/types'

const { i18n } = localization

const I18_PATH = `${namespace}:manager.schedules`

class SchedulesUtils {
  getScheduleStatusLocalization(status: VirtualEventScheduleStatus): string {
    const STATUS_LOCALIZATION: Record<VirtualEventScheduleStatus, string> = {
      [VirtualEventScheduleStatus.Undefined]: i18n.t(`${I18_PATH}.statuses.draft`),
      [VirtualEventScheduleStatus.Open]: i18n.t(`${I18_PATH}.statuses.open`),
      [VirtualEventScheduleStatus.Published]: i18n.t(`${I18_PATH}.statuses.published`),
      [VirtualEventScheduleStatus.Started]: i18n.t(`${I18_PATH}.statuses.started`),
      [VirtualEventScheduleStatus.Ended]: i18n.t(`${I18_PATH}.statuses.ended`),
      [VirtualEventScheduleStatus.Cancelled]: i18n.t(`${I18_PATH}.statuses.cancelled`),
    }
    return STATUS_LOCALIZATION[status]
  }
}

export default new SchedulesUtils()
